// USER
export const SWR_USER_REGISTER = 'SWR_USER_REGISTER'
export const SWR_USER_SCORE = 'SWR_USER_SCORE'
export const SWR_USER_PHONE_LEAKS = 'SWR_USER_PHONE_LEAKS'
export const SWR_USER_ADDRESS_LEAKS = 'SWR_USER_ADDRESS_LEAKS'
export const SWR_USER_NAME_LEAKS = 'SWR_USER_NAME_LEAKS'
export const SWR_USER_SCAN = 'SWR_USER_SCAN'
export const SWR_USER_DASHBOARD = 'SWR_USER_DASHBOARD'
export const SWR_USER_DASHBOARD_V2 = 'SWR_USER_DASHBOARD_V2'
export const SWR_USER_ALL_LEAKS = 'SWR_USER_ALL_LEAKS'
export const SWR_USER_NAME_REPORTS = 'SWR_USER_NAME_REPORTS'
export const SWR_USER_ADDRESS_REPORTS = 'SWR_USER_ADDRESS_REPORTS'
export const SWR_USER_PHONE_REPORTS = 'SWR_USER_PHONE_REPORTS'

// RESPONSE PLAN
export const SWR_RESPONSE_PLAN = 'SWR_RESPONSE_PLAN_REGISTER'

// COMPANY
export const SWR_COMPANY = 'SWR_COMPANY'
export const SWR_COMPANY_ADMINS = 'SWR_COMPANY_ADMINS'
export const SWR_COMPANY_INVITES = 'SWR_COMPANY_INVITES'
export const SWR_COMPANY_BATCH_SCAN = 'SWR_COMPANY_BATCH_SCAN'
export const SWR_COMPANY_DASHBOARD = 'SWR_COMPANY_DASHBOARD'
export const SWR_COMPANY_SCORE_TREND = 'SWR_COMPANY_SCORE_TREND'

// PAYMENT
export const SWR_PAYMENT_HISTORY = 'SWR_PAYMENT_HITORY'

// SCAN
export const SWR_SCAN_STATUS = 'SWR_SCAN_STATUS'
